"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _MaterialIcon = _interopRequireDefault(require("../MaterialIcon"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = require("styled-components");
var _styled = require("./styled");
var _react = _interopRequireWildcard(require("react"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const FormGroup = _ref => {
  let {
    children,
    collapse = false,
    color,
    comment,
    commentColor,
    defaultCollapsed = false,
    height,
    label,
    labelMarginBottom = '5px',
    margin,
    marginBottom,
    marginTop,
    noPrint,
    order = 0,
    padding,
    size = '12px',
    tabIndex,
    textAlign,
    width
  } = _ref;
  const {
    labelColor
  } = (0, _styledComponents.useTheme)();
  const [collapsed, setCollapsed] = (0, _react.useState)(false);
  (0, _react.useEffect)(() => {
    setCollapsed(defaultCollapsed);
  }, [defaultCollapsed, setCollapsed]);
  const containerProps = {
    height,
    margin,
    marginBottom,
    marginTop,
    noPrint,
    order,
    padding,
    tabIndex,
    textAlign,
    width
  };
  const labelProps = {
    collapse,
    color,
    labelMarginBottom,
    onClick: !collapse ? undefined : () => setCollapsed(collapsed => !collapsed),
    size
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styled.Container, _objectSpread(_objectSpread({}, containerProps), {}, {
    "data-testid": "Container",
    children: [!!label && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styled.Label, _objectSpread(_objectSpread({}, labelProps), {}, {
      "data-testid": "Label",
      children: [label, !!collapse && /*#__PURE__*/(0, _jsxRuntime.jsx)(_MaterialIcon.default, {
        color: labelColor,
        icon: collapsed ? 'expand_more' : 'expand_less',
        margin: "0px 0px 0px 5px",
        size: parseInt(size, 10)
      })]
    })), (!collapse || !collapsed) && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [children, !!comment && /*#__PURE__*/(0, _jsxRuntime.jsx)(_styled.Comment, {
        color: commentColor,
        "data-testid": "Comment",
        children: comment
      })]
    })]
  }));
};
FormGroup.propTypes = {
  children: _propTypes.default.any,
  collapse: _propTypes.default.bool,
  color: _propTypes.default.string,
  comment: _propTypes.default.string,
  commentColor: _propTypes.default.string,
  defaultCollapsed: _propTypes.default.bool,
  height: _propTypes.default.string,
  label: _propTypes.default.string,
  labelMarginBottom: _propTypes.default.string,
  margin: _propTypes.default.string,
  marginBottom: _propTypes.default.string,
  marginTop: _propTypes.default.string,
  noPrint: _propTypes.default.bool,
  order: _propTypes.default.number,
  padding: _propTypes.default.string,
  size: _propTypes.default.string,
  tabIndex: _propTypes.default.number,
  textAlign: _propTypes.default.string,
  width: _propTypes.default.string
};
var _default = exports.default = FormGroup;